/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AccountOptionDtoFromJSON, CreateUpdateAccountStrutturaBusinessDtoFromJSON, CreateUpdateAccountStrutturaBusinessDtoToJSON, CreateUpdateProjectQuoteDtoFromJSON, CreateUpdateProjectQuoteDtoToJSON, ProjectPastDataDatailFromJSON, SavePastDataForProjectToJSON, } from '../models/index';
/**
 *
 */
export class ControllerDedicatoAFunzioniSoloPerAmministratoriApi extends runtime.BaseAPI {
    /**
     * Attiva un progetto intranet
     */
    activateIntranetProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling activateIntranetProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/{projectId}/activateIntranetProject`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Attiva un progetto intranet
     */
    activateIntranetProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activateIntranetProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i possibili valori che un progetto può assumere
     * Possibili valori
     */
    adminCreateIntranetProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling adminCreateIntranetProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/crete-project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Recupera tutti i possibili valori che un progetto può assumere
     * Possibili valori
     */
    adminCreateIntranetProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminCreateIntranetProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Abilita le persone pianificate a rendicontare, aggiornando il loro stato sulla intranet
     * Allinea il personale pianificato sulla intranet
     */
    alignPlannedPersonnelIntranetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling alignPlannedPersonnelIntranet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/align-personnel/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Abilita le persone pianificate a rendicontare, aggiornando il loro stato sulla intranet
     * Allinea il personale pianificato sulla intranet
     */
    alignPlannedPersonnelIntranet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.alignPlannedPersonnelIntranetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Crea il progetto e la quote passandogli i vari parametri
     * Crea progetto e quote
     */
    createProjectAndQuoteAdminRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createUpdateProjectQuoteDto'] == null) {
                throw new runtime.RequiredError('createUpdateProjectQuoteDto', 'Required parameter "createUpdateProjectQuoteDto" was null or undefined when calling createProjectAndQuoteAdmin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/create`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateUpdateProjectQuoteDtoToJSON(requestParameters['createUpdateProjectQuoteDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CreateUpdateProjectQuoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Crea il progetto e la quote passandogli i vari parametri
     * Crea progetto e quote
     */
    createProjectAndQuoteAdmin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createProjectAndQuoteAdminRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Elimina la/le riga/righe di account_struttura_business identificate dalla coppia (idAccount, idStrutturaBusiness). Operazione idempotente.
     * Elimina associazione cliente-struttura
     */
    deleteAccountStrutturaBusinessRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idAccount'] == null) {
                throw new runtime.RequiredError('idAccount', 'Required parameter "idAccount" was null or undefined when calling deleteAccountStrutturaBusiness().');
            }
            if (requestParameters['idStrutturaBusiness'] == null) {
                throw new runtime.RequiredError('idStrutturaBusiness', 'Required parameter "idStrutturaBusiness" was null or undefined when calling deleteAccountStrutturaBusiness().');
            }
            const queryParameters = {};
            if (requestParameters['idAccount'] != null) {
                queryParameters['idAccount'] = requestParameters['idAccount'];
            }
            if (requestParameters['idStrutturaBusiness'] != null) {
                queryParameters['idStrutturaBusiness'] = requestParameters['idStrutturaBusiness'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/account-struttura-business`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Elimina la/le riga/righe di account_struttura_business identificate dalla coppia (idAccount, idStrutturaBusiness). Operazione idempotente.
     * Elimina associazione cliente-struttura
     */
    deleteAccountStrutturaBusiness(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteAccountStrutturaBusinessRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Consente di eliminare una fattura progetto tramite il suo ID
     * Elimina una fattura competenza mese anno
     */
    deleteFatturaCompetenzaMeseAnnoAttivo1Raw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling deleteFatturaCompetenzaMeseAnnoAttivo1().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/competenza_meseanno_fattura_attivo_delete/{idProject}`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Consente di eliminare una fattura progetto tramite il suo ID
     * Elimina una fattura competenza mese anno
     */
    deleteFatturaCompetenzaMeseAnnoAttivo1(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteFatturaCompetenzaMeseAnnoAttivo1Raw(requestParameters, initOverrides);
        });
    }
    /**
     * Restituisce gli account legati alla struttura indicata.
     * Elenco account associati a una struttura
     */
    getAccountsByStrutturaRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idStruttura'] == null) {
                throw new runtime.RequiredError('idStruttura', 'Required parameter "idStruttura" was null or undefined when calling getAccountsByStruttura().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/account-struttura-business/struttura/{idStruttura}`.replace(`{${"idStruttura"}}`, encodeURIComponent(String(requestParameters['idStruttura']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AccountOptionDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce gli account legati alla struttura indicata.
     * Elenco account associati a una struttura
     */
    getAccountsByStruttura(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAccountsByStrutturaRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce l\'elenco completo della tabella ciclo_attivo.account, anche degli account non ancora associati ad alcuna struttura.
     * Elenco account
     */
    getAllAccountStrutturaBusinessRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/account-struttura-business/accounts`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AccountOptionDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce l\'elenco completo della tabella ciclo_attivo.account, anche degli account non ancora associati ad alcuna struttura.
     * Elenco account
     */
    getAllAccountStrutturaBusiness(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllAccountStrutturaBusinessRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i dettagli del progetto e della quote passandogli l\'id del progetto
     * Recupera project e quote
     */
    getProjectAndQuoteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getProjectAndQuote().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CreateUpdateProjectQuoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i dettagli del progetto e della quote passandogli l\'id del progetto
     * Recupera project e quote
     */
    getProjectAndQuote(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProjectAndQuoteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Permette di associare una fattura progetto esistente.
     * Associa una fattura in maniera automatica al progetto
     */
    ricolcolaAutomaticFattureProject1Raw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling ricolcolaAutomaticFattureProject1().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/ricalcola-fatture-automatico/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Permette di associare una fattura progetto esistente.
     * Associa una fattura in maniera automatica al progetto
     */
    ricolcolaAutomaticFattureProject1(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.ricolcolaAutomaticFattureProject1Raw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Se il DTO arriva senza id viene creata una nuova associazione; se l\'id è valorizzato viene aggiornato il record esistente.
     * Crea o aggiorna un\'associazione account-struttura business
     */
    saveAccountStrutturaBusinessRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createUpdateAccountStrutturaBusinessDto'] == null) {
                throw new runtime.RequiredError('createUpdateAccountStrutturaBusinessDto', 'Required parameter "createUpdateAccountStrutturaBusinessDto" was null or undefined when calling saveAccountStrutturaBusiness().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/account-struttura-business`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateUpdateAccountStrutturaBusinessDtoToJSON(requestParameters['createUpdateAccountStrutturaBusinessDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CreateUpdateAccountStrutturaBusinessDtoFromJSON(jsonValue));
        });
    }
    /**
     * Se il DTO arriva senza id viene creata una nuova associazione; se l\'id è valorizzato viene aggiornato il record esistente.
     * Crea o aggiorna un\'associazione account-struttura business
     */
    saveAccountStrutturaBusiness(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveAccountStrutturaBusinessRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Modifica il progetto e la quote passandogli i vari parametri (modifica la quote tramite il project id e la quote attiva
     * Modifica progetto e quote
     */
    updateProjectAndQuoteAdminRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling updateProjectAndQuoteAdmin().');
            }
            if (requestParameters['createUpdateProjectQuoteDto'] == null) {
                throw new runtime.RequiredError('createUpdateProjectQuoteDto', 'Required parameter "createUpdateProjectQuoteDto" was null or undefined when calling updateProjectAndQuoteAdmin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CreateUpdateProjectQuoteDtoToJSON(requestParameters['createUpdateProjectQuoteDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CreateUpdateProjectQuoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Modifica il progetto e la quote passandogli i vari parametri (modifica la quote tramite il project id e la quote attiva
     * Modifica progetto e quote
     */
    updateProjectAndQuoteAdmin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateProjectAndQuoteAdminRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce un progetto con i dati di costi e plan consolidati fino a quel momento
     * Salva revenue plan e costi esterni
     */
    updateProjectWithRevenutAndOtherCostsCostsByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling updateProjectWithRevenutAndOtherCostsCostsById().');
            }
            if (requestParameters['savePastDataForProject'] == null) {
                throw new runtime.RequiredError('savePastDataForProject', 'Required parameter "savePastDataForProject" was null or undefined when calling updateProjectWithRevenutAndOtherCostsCostsById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/past-data/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SavePastDataForProjectToJSON(requestParameters['savePastDataForProject']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPastDataDatailFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce un progetto con i dati di costi e plan consolidati fino a quel momento
     * Salva revenue plan e costi esterni
     */
    updateProjectWithRevenutAndOtherCostsCostsById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateProjectWithRevenutAndOtherCostsCostsByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Aggiorna i costi HR e gli altri costi presenti in rendicontazione per mese anno e progetto indicati
     * Aggiorna i costi HR e gli altri costi presenti in rendicontazione
     */
    updateReportingCostForProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling updateReportingCostForProject().');
            }
            if (requestParameters['year'] == null) {
                throw new runtime.RequiredError('year', 'Required parameter "year" was null or undefined when calling updateReportingCostForProject().');
            }
            if (requestParameters['month'] == null) {
                throw new runtime.RequiredError('month', 'Required parameter "month" was null or undefined when calling updateReportingCostForProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/past-data/{projectId}/{year}/{month}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"year"}}`, encodeURIComponent(String(requestParameters['year']))).replace(`{${"month"}}`, encodeURIComponent(String(requestParameters['month']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPastDataDatailFromJSON(jsonValue));
        });
    }
    /**
     * Aggiorna i costi HR e gli altri costi presenti in rendicontazione per mese anno e progetto indicati
     * Aggiorna i costi HR e gli altri costi presenti in rendicontazione
     */
    updateReportingCostForProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateReportingCostForProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Aggiorna i dati della Triade Intranet in base all\'id del progetto
     * Aggiorna dati Triade Intranet
     */
    updateTriadeIntranetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling updateTriadeIntranet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/administration/update-triade/{idProject}`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Aggiorna i dati della Triade Intranet in base all\'id del progetto
     * Aggiorna dati Triade Intranet
     */
    updateTriadeIntranet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateTriadeIntranetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
